import { ReactNode } from 'react';
import { Box } from '@mui/material';

type AccordionGroupProps = {
  /**
   * Ger den öppna panelens innehåll systemets kortbakgrund, samma som formuläret i utökad
   * sökning. Använd när panelen innehåller ett formulär, det blir tydligare var det börjar
   * och slutar.
   */
  cardContent?: boolean;
  children: ReactNode;
};

/**
 * Systemets utseende för en grupp accordions: pilen till vänster om rubriken, roterad när
 * panelen är öppen, och en tunn avgränsning under den öppna panelen.
 *
 * Samma stil användes redan på flera håll men var inklistrad i varje komponent. Nya grupper
 * ska använda den här i stället, så att utseendet ändras på ett ställe.
 */
export const AccordionGroup = (props: AccordionGroupProps) => {
  const { cardContent = false, children } = props;

  return (
    <Box
      sx={{
        '& .MuiAccordionSummary-root': {
          flexDirection: 'row-reverse',
          '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
          },
          '& .MuiAccordionSummary-content': {
            ml: 1,
          },
        },
        '& .MuiAccordion-root.Mui-expanded': {
          borderBottom: '1px solid #e0e0e0',
          boxShadow: '0 20px 15px -20px rgba(0, 0, 0, 0.1) inset !important',
          margin: 0,
        },
        ...(cardContent && {
          // Samma värden som systemets card (advancedSearch.tsx, utökad sökning). Forka inte
          // färgerna, ändra här om kortet ska se annorlunda ut.
          '& .MuiAccordionDetails-root': {
            backgroundColor: (thm) => thm.palette.background.default,
            borderRadius: 1,
            border: '1px solid rgba(0,0,0,0.05)',
            p: 2,
            mx: 2,
            mb: 2,
            '& .MuiInputBase-root': {
              backgroundColor: '#fff',
            },
          },
        }),
      }}
    >
      {children}
    </Box>
  );
};
